import { Order } from '@components/account/types'
import { resizeShopifyImage } from '@helpers/shopify'

export function getOrderImages(
  fulfillments: Partial<Order>['fulfillments'],
  lineItems: Partial<Order>['lineItems']
): (string | undefined)[] {
  const imageMap = new Map<string, string | undefined>()

  fulfillments?.forEach(fulfillment => {
    fulfillment.fulfillmentLineItems?.forEach(item => {
      const variantId = item.lineItem.variantId

      if (variantId && !imageMap.has(variantId)) {
        imageMap.set(
          variantId,
          item.lineItem.image?.url
            ? resizeShopifyImage(item.lineItem.image?.url, {
                width: '164',
                height: '248',
                crop: 'center'
              })
            : undefined
        )
      }
    })
  })

  lineItems?.forEach(item => {
    const variantId = item.variantId

    if (variantId && !imageMap.has(variantId)) {
      imageMap.set(
        variantId,
        item.image?.url
          ? resizeShopifyImage(item.image?.url, {
              width: '164',
              height: '248',
              crop: 'center'
            })
          : undefined
      )
    }
    if (!variantId) {
      imageMap.set(item.productId, undefined)
    }
  })
  return Array.from(imageMap.values())
}
